import * as React from "react";

import {
  Box,
  Slide,
  DialogContent,
  Dialog,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NoInternet({ open, onRefresh }) {
  const { t } = useTranslation("common");
  return (
    <Box color="default">
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "#00000070",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 0,
            padding: 16,
            width: "100%",
            height: "100%",
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <svg width="114" height="114" viewBox="0 0 114 114">
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_5969"
                  data-name="Rectangle 5969"
                  width="114"
                  height="114"
                  transform="translate(-4048 3637)"
                  fill="#fff"
                  stroke="#707070"
                  stroke-width="1"
                />
              </clipPath>
            </defs>
            <g
              id="Group_10364"
              data-name="Group 10364"
              transform="translate(4048 -3637)"
            >
              <g
                id="Icon_No_wifi"
                data-name="Icon/No_wifi"
                clip-path="url(#clip-path)"
              >
                <g
                  id="Group_10363"
                  data-name="Group 10363"
                  transform="translate(59 83)"
                >
                  <g
                    id="Path_10733"
                    data-name="Path 10733"
                    transform="translate(-4107 3554)"
                    fill="none"
                  >
                    <path
                      d="M57,0A57,57,0,1,1,0,57,57,57,0,0,1,57,0Z"
                      stroke="none"
                    />
                    <path
                      d="M 57 5 C 49.97783660888672 5 43.16838073730469 6.374183654785156 36.76078033447266 9.084358215332031 C 30.56925964355469 11.70316314697266 25.00763702392578 15.45323944091797 20.23043823242188 20.23043823242188 C 15.45323944091797 25.00763702392578 11.70316314697266 30.56925964355469 9.084358215332031 36.76078033447266 C 6.374183654785156 43.16838073730469 5 49.97783660888672 5 57 C 5 64.02215576171875 6.374183654785156 70.83161926269531 9.084358215332031 77.23921966552734 C 11.70316314697266 83.43074035644531 15.45323944091797 88.99235534667969 20.23043823242188 93.76956176757812 C 25.00763702392578 98.54676055908203 30.56925964355469 102.2968368530273 36.76078033447266 104.915641784668 C 43.16838073730469 107.6258239746094 49.97783660888672 109 57 109 C 64.02215576171875 109 70.83161926269531 107.6258239746094 77.23921966552734 104.915641784668 C 83.43074035644531 102.2968368530273 88.99235534667969 98.54676055908203 93.76956176757812 93.76956176757812 C 98.54676055908203 88.99235534667969 102.2968368530273 83.43074035644531 104.915641784668 77.23921966552734 C 107.6258239746094 70.83161926269531 109 64.02215576171875 109 57 C 109 49.97783660888672 107.6258239746094 43.16838073730469 104.915641784668 36.76078033447266 C 102.2968368530273 30.56925964355469 98.54676055908203 25.00763702392578 93.76956176757812 20.23043823242188 C 88.99235534667969 15.45323944091797 83.43074035644531 11.70316314697266 77.23921966552734 9.084358215332031 C 70.83161926269531 6.374183654785156 64.02215576171875 5 57 5 M 57 0 C 88.48023986816406 0 114 25.51976013183594 114 57 C 114 88.48023986816406 88.48023986816406 114 57 114 C 25.51976013183594 114 0 88.48023986816406 0 57 C 0 25.51976013183594 25.51976013183594 0 57 0 Z"
                      stroke="none"
                      fill="#fff"
                    />
                  </g>
                  <path
                    id="Path_10732"
                    data-name="Path 10732"
                    d="M34.322,50.769a3.611,3.611,0,1,1,3.611-3.611A3.615,3.615,0,0,1,34.322,50.769ZM44.534,40.554a3.576,3.576,0,0,1-2.551-1.06,11.056,11.056,0,0,0-7.66-3.066h-.159l2.918-7.117a17.912,17.912,0,0,1,10,5.076,3.614,3.614,0,0,1-2.552,6.167Zm-20.425,0a3.612,3.612,0,0,1-2.551-6.166,18,18,0,0,1,8.712-4.829L25.976,40.032A3.6,3.6,0,0,1,24.11,40.553ZM54.75,30.341a3.586,3.586,0,0,1-2.551-1.06A25.253,25.253,0,0,0,39.872,22.5l2.772-6.761a32.523,32.523,0,0,1,14.665,8.431,3.613,3.613,0,0,1-2.558,6.166Zm-40.859,0a3.611,3.611,0,0,1-2.555-6.164,32.329,32.329,0,0,1,22.985-9.507c.674,0,1.356.021,2.028.063l-2.943,7.178a25.24,25.24,0,0,0-16.96,7.372A3.589,3.589,0,0,1,13.891,30.339ZM65,20.086a3.623,3.623,0,0,1-2.422-.93A47.284,47.284,0,0,0,45.466,8.86L48.2,2.185A54.554,54.554,0,0,1,67.423,13.793a3.615,3.615,0,0,1,.263,5.1A3.568,3.568,0,0,1,65,20.086Zm-61.395,0a3.611,3.611,0,0,1-2.542-6.179A54.286,54.286,0,0,1,21.162,2.167,44.718,44.718,0,0,1,34.776,0a42.285,42.285,0,0,1,7.347.645l-2.8,6.838a34.545,34.545,0,0,0-4.474-.292A37.761,37.761,0,0,0,23.359,9.048,47.947,47.947,0,0,0,6.152,19.043,3.6,3.6,0,0,1,3.61,20.086Z"
                    transform="translate(-4085 3586)"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
          </svg>
          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Typography className="fs-22 fw-b">
              {t("noInternet.text1")}
            </Typography>
            <Typography className="fs-14">{t("noInternet.text2")}</Typography>
            <Button onClick={onRefresh} variant="contained" color="primary">
              {" "}
              {t("noInternet.text3")}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
